/**
 * Resolves internal showcase markdown link tokens to app-relative routes.
 *
 * Supported tokens:
 * - `{{showcaseRoot}}` -> `/libraryShowcase`
 * - `{{libraryBase}}` -> `/libraryShowcase/{currentLibSlug}`
 * - `{{libraryBase:<lib>}}` -> `/libraryShowcase/{slug(<lib>)}`
 */
export function resolveShowcaseLinkTokens(markdown: string | undefined, currentLibName?: string): string {
  if (!markdown) {
    return '';
  }

  const showcaseRoot = '/libraryShowcase';
  const currentLibSlug = toSlug(currentLibName ?? '');
  const currentLibraryBase = currentLibSlug ? `${showcaseRoot}/${currentLibSlug}` : showcaseRoot;

  return markdown
    .replaceAll('{{showcaseRoot}}', showcaseRoot)
    .replaceAll('{{libraryBase}}', currentLibraryBase)
    .replace(/\{\{libraryBase:([^}]+)\}\}/g, (_match: string, libSegment: string) => {
      const targetSlug = toSlug(libSegment);
      return targetSlug ? `${showcaseRoot}/${targetSlug}` : showcaseRoot;
    });
}

function toSlug(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

